import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Services as ServicesV2 } from './v2';
import { ServicesContainer as ServicesV1 } from './v1';
import { selectCompetitorsExperiment } from '../../../../../../selectors/experiments';
import { ElementInViewport } from '../../../../../common/ElementInViewport';
import { useServicesAnalytics } from './hooks';
import { ServicesLoaderMask } from './components';
import { selectIsServicesReloading } from '../../../../../../reducers/v2/ui/selectors';

export const ServicesContainer = () => {
  const isLoading = useSelector(selectIsServicesReloading);

  const showServicesV2 = useSelector(selectCompetitorsExperiment);
  const { trackServicesShow, trackDiffPricingShow } = useServicesAnalytics();

  const handleServicesShows = useCallback(() => {
    trackServicesShow();
    trackDiffPricingShow();
  }, [trackServicesShow, trackDiffPricingShow]);

  return (
    <ElementInViewport threshold={0.25} onVisible={handleServicesShows}>
      <ServicesLoaderMask isLoading={isLoading}>{showServicesV2 ? <ServicesV2 /> : <ServicesV1 />}</ServicesLoaderMask>
    </ElementInViewport>
  );
};
